// src/store/preferences/preferencesEpic.ts
import { Observable } from "rxjs";
import { ofType } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import AuthService from "@/services/AuthService";
import {
  fetchCurrentClientPreferences,
  fetchCurrentClientPreferencesSuccess,
  fetchCurrentClientPreferencesFailure,
  fetchCurrentClient,
  fetchCurrentClientSuccess,
  fetchCurrentClientFailure,
} from "./preferencesSlice";

const fetchCurrentClientPreferencesEpic = (action$: Observable<any>) =>
  action$.pipe(
    ofType(fetchCurrentClientPreferences.type),
    switchMap((action) =>
      AuthService.getCurrentClientPreferences(action.payload).pipe(
        map((preferences) => fetchCurrentClientPreferencesSuccess(preferences)),
        catchError((error) =>
          of(fetchCurrentClientPreferencesFailure(error.message || "Failed to fetch current client preferences"))
        )
      )
    )
  );

const fetchCurrentClientEpic = (action$: Observable<any>) =>
  action$.pipe(
    ofType(fetchCurrentClient.type),
    switchMap(() =>
      AuthService.getCurrentClient().pipe(
        map((client) => fetchCurrentClientSuccess(client)),
        catchError((error) =>
          of(fetchCurrentClientFailure(error.message || "Failed to fetch current client"))
        )
      )
    )
  );

export const preferencesEpics = [fetchCurrentClientPreferencesEpic, fetchCurrentClientEpic];